import { Box, Container, Grid, Typography } from "@mui/material"
import { styled } from "@mui/material/styles"
import { useApi } from "auth/useApi3"
import ClpTable from "components/ClpTable"
import { apiEndpoints } from "generated/apiEndpoints"
import moment from "moment"
import React, { useEffect, useState } from "react"
import { StyledTableContainer } from "shared/styled/Global"
import { Overview } from "./components/overview/Overview"
import { useTranslation } from "react-i18next"

const StyledBox = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "end"
}))

const Devices = () => {
  const { t } = useTranslation()
  const [deviceRegistryResult, deviceRegistryFunc] = useApi()
  const [deviceRegistryBoxesResult, deviceRegistryBoxesFunc] = useApi()

  useEffect(() => {
    deviceRegistryFunc.get(apiEndpoints.systemadmindeviceregistry.getdashboarddata)
    return () => {
      deviceRegistryFunc.leave()
    }
  }, [deviceRegistryFunc])

  React.useEffect(() => {
    const interval = setInterval(() => {
      deviceRegistryBoxesFunc.get(apiEndpoints.systemadmindeviceregistry.getdashboarddata)
    }, 10000)

    return () => {
      deviceRegistryBoxesFunc.leave()
      clearInterval(interval)
    }
  }, [deviceRegistryBoxesFunc])

  const [overviewData, setOverviewData] = useState(null)
  const [timestamp, setTimestamp] = useState("")

  React.useEffect(() => {
    if (deviceRegistryBoxesResult.status === 2 || deviceRegistryResult.status === 2) {
      setOverviewData(
        deviceRegistryBoxesResult.data ? deviceRegistryBoxesResult.data : deviceRegistryResult.data
      )
      setTimestamp(moment().format("YYYY-MM-DD HH:mm:ss"))
    }
  }, [deviceRegistryBoxesResult])

  const columns = [
    {
      accessorKey: "deviceId",
      header: t("global.table.id", "ID")
    },
    {
      accessorKey: "internalDeviceId",
      header: t("global.table.internal_number", "Internal no")
    },
    {
      accessorKey: "imei",
      Header: t("global.imei", "IMEI")
    },
    {
      accessorKey: "companyName",
      header: t("global.company", "Company")
    },
    {
      accessorKey: "fuelUsed",
      header: t("global.totalfuel", "Totalfuel")
    },
    {
      accessorKey: "odometer",
      header: t("global.odometer", "Odometer")
    },
    {
      accessorFn: (row) => {
        return row.latestTimeGps ? moment(row.latestTimeGps).format("YYYY-MM-DD HH:mm") : ""
      },
      header: t("global.gps_time", "GPS time")
    },
    {
      accessorFn: (row) => {
        return row.alcoholAlarmIsNotActive !== null && !row.alcoholAlarmIsNotActive ? "Ja" : "-"
      },
      header: t("global.alcohol_lock_active", "Alcohol lock active")
    },
    {
      accessorFn: (row) => {
        return row.driverCardIsNotActive !== null && !row.driverCardIsNotActive ? "Ja" : "-"
      },
      header: t("global.immobilizer_active", "Immobilizer active")
    },
    {
      accessorFn: (row) => {
        return row.latestTimeOnline ? moment(row.latestTimeOnline).format("YYYY-MM-DD HH:mm") : ""
      },
      header: t("global.online", "Online")
    }
  ]

  return (
    <div>
      <Container>
        <Box mb={5}>
          <Typography variant="h1">{t("global.overview", "Overview")}</Typography>
        </Box>

        <Box column>
          <StyledBox mb={1}>
            <Typography variant="bodySmall">
              {t("global.table.last_updated", "Last updated")}: {timestamp}
            </Typography>
          </StyledBox>
          <Grid container spacing={2}>
            <Overview
              overviewData={deviceRegistryResult.status === 2 ? deviceRegistryResult.data : overviewData}
            />
          </Grid>
        </Box>
      </Container>
      <StyledTableContainer>
        <ClpTable
          columns={columns}
          rows={deviceRegistryResult.status === 2 && deviceRegistryResult.data?.deviceData}
          loadingState={deviceRegistryResult.status}
        />
      </StyledTableContainer>
    </div>
  )
}

export default Devices
